module.exports = __webpack_public_path__ + "static/media/Lake-Village-II-MasterDeed.b038c186.pdf";